module.exports = __webpack_public_path__ + "media/images/icon-zoom-7dc69fe9bb2366715a99a4daf9c70ffb.svg";